import React from "react";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import classes from './QuestionText.module.css'

const QuestionText = ({ longAnswer, correctAnswers, onDataChange }) => {
    
    const { texts } = useSelector(state => state.translate);

    useEffect(() => {
        if (longAnswer === true && correctAnswers.length > 0) {
            onDataChange({ correctAnswers: [] })
        }
    }, [longAnswer])

    const handleAddCorrectAns = () => {
        onDataChange({ correctAnswers: [...correctAnswers, ''] })
    }

    const handleRemoveCorrectAns = (index) => {
        const newCorrectAnswers = [...correctAnswers];
        newCorrectAnswers.splice(index, 1);
        onDataChange({ correctAnswers: newCorrectAnswers })
    }

    const handleChangeCorrectAns = (index, e) => {
        const newCorrectAnswers = [...correctAnswers];
        newCorrectAnswers[index] = e.target.value
        onDataChange({ correctAnswers: newCorrectAnswers })
    }

    return <div className={classes.QuestionText}>
        {longAnswer ?
            <textarea className={classes.AnsDemo} readOnly={true} disabled={true}>{texts.answer}</textarea> :
            <input className={classes.AnsDemo} disabled={true} readOnly={true} placeholder={texts.answer} type='text'></input>
        }
        {
            !longAnswer && <>
                <div className={classes.AnswersText}>{texts.correctAnswers}:</div>
                <div className={classes.AnsList}>
                    {correctAnswers && correctAnswers.map((ans, ansIndex) => <div className={classes.Ans} key={ansIndex}>
                        <input className={classes.AnsInput} type='text' style={{ width: (ans.length + 1) * 0.8 + 'ch' }} value={ans} onChange={(e) => handleChangeCorrectAns(ansIndex, e)} />
                        <div className={classes.Delete} onClick={() => handleRemoveCorrectAns(ansIndex)}></div>
                    </div>)}
                    <div className={classes.AddAnsBtn} onClick={handleAddCorrectAns}>
                        <div className={classes.Plus}>+</div>
                        <div>{texts.addAnswer}</div>
                    </div>
                </div>
            </>
        }
    </div>

}
export default QuestionText;